import React, { useEffect } from "react";
import Header from "../components/Header";

export default function SupportPage({ navigate, user, onLogin, onAccount, showBlog = true, onShareSite }) {
  useEffect(() => {
    document.title = "СоцПлан | Поддержка";
  }, []);
  return (
    <div className="min-h-screen bg-slate-100 py-6 md:py-10">
      <div className="mx-auto w-full max-w-5xl rounded-2xl border bg-white shadow-md">
        <Header
          navigate={navigate}
          user={user}
          onLogin={onLogin}
          onAccount={onAccount}
          showBlog={showBlog}
          onShareSite={onShareSite}
        />
        <section className="px-5 md:px-6 py-6">
          <h1 className="text-2xl font-bold mb-4">Поддержка</h1>
          <p className="text-slate-700">Свяжитесь с нами по адресу sotsplan@ya.ru.</p>
        </section>
      </div>
    </div>
  );
}
